var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#74b197"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9381 12.8369C8.9309 12.8369 8.9237 12.8375 8.9165 12.8375C8.2541 12.8483 7.72551 13.3955 7.73751 14.0573C7.74891 14.7137 8.2835 15.2363 8.9375 15.2363H8.9585C9.6203 15.2243 10.1489 14.6783 10.1375 14.0165C10.1255 13.3601 9.5915 12.8369 8.9381 12.8369Z",
    fill: "#017848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91797 2.83716C9.43081 2.83716 9.85349 3.17123 9.91125 3.60162L9.91798 3.70254V10.9718C9.91798 11.4497 9.47026 11.8372 8.91797 11.8372C8.40514 11.8372 7.98246 11.5031 7.9247 11.0727L7.91797 10.9718V3.70254C7.91797 3.2246 8.36569 2.83716 8.91797 2.83716Z",
    fill: "#017848"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenAlert);
export default __webpack_public_path__ + "static/media/green-alert.481bc2e6.svg";
export { ForwardRef as ReactComponent };